import React from 'react';

import { TextInputField } from '../../../../helpers'
import { getUOMStr, round } from '../../../../utils';
import "../index.css"


const DispatchSellerPOItemsStock = (props) => {
    const { buyerReqItemId, sellerPOItem, displayLabel, isQtyCannotBeChanged, isAllDispatchItemsConvertedToStock } = props

    let labelName = ""
    if(displayLabel){
        if(isQtyCannotBeChanged){
            labelName = "Stock Qty"
        }else{
            labelName = "Dispatch Qty"
        }
    }

    let UOMStr = getUOMStr(sellerPOItem.UOM, sellerPOItem.UOMValue)

    const isServiceHSNProduct = sellerPOItem.HSNCode.toString().slice(0, 2) === '99' && sellerPOItem.HSNCode.toString().length === 6

    return (
        <div key={`sellerPOItem-${sellerPOItem.sellerPOItemId}`} className="grid align-items-center">
            <div className="flex flex-wrap col-12 md:col-12 lg:col-12 pl-0 pb-0">
                <div className="grid">
                    <div className="flex flex-column col-12 md:col-6 lg:col-2 w-9rem">
                        <TextInputField name="SellerPONo" labelText={displayLabel && "SellerPO No"} value={sellerPOItem.docNo} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-6 lg:col-2 w-9rem">
                        <TextInputField name="BuyerPO No" labelText={displayLabel && "BuyerPO No"} value={sellerPOItem.bPOdocNo} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-6 lg:col-6 w-7rem">
                        <TextInputField name="sellerPOQty" labelText={displayLabel && "SellerPO Qty"} value={sellerPOItem.qty} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-6 lg:col-6 w-7rem">
                        <TextInputField name="totalAcceptedQuantity" labelText={displayLabel && "TTL Acpt. Qty"} value={sellerPOItem.totalAcceptedQuantity} disabled />
                    </div>
                    <div className="flex flex-column col-12 md:col-6 lg:col-12 w-9rem">
                        <TextInputField name="totalDispatchQty" labelText={displayLabel && "TTL Dispatched Qty"} value={round(sellerPOItem.stockDispatchQty)} disabled />
                    </div>
                    {
                        isQtyCannotBeChanged && 
                            <div className="flex flex-column col-12 md:col-6 lg:col-2 w-7rem">
                                <TextInputField name="totalConvertedQty" labelText={displayLabel && "TTL Conv. Qty"} value={round(sellerPOItem.totalConvertedQty)} disabled />
                            </div>
                    }
                    <div className="flex flex-column col-12 md:col-5 lg:col-6 w-6rem">
                        <TextInputField name="availableQty" labelText={displayLabel && "Available Qty"} value={sellerPOItem.availableDispatchQuantity} disabled /> {/*// round(sellerPOItem.totalAcceptedQuantity - sellerPOItem.totalDispatchQty,2) */}
                    </div>
                    <div className="flex flex-column col-12 md:col-7 lg:col-6 w-8rem">
                        <TextInputField 
                            name="convertToStockQty" 
                            labelText={displayLabel && `${labelName} (${UOMStr})`} 
                            value={isQtyCannotBeChanged ? sellerPOItem.convertToStockQty : sellerPOItem.dispatchQty} 
                            disabled={isAllDispatchItemsConvertedToStock || sellerPOItem?.availableDispatchQuantity === 0} // || isServiceHSNProduct} 
                            keyfilter="pnum" 
                            onChange={(event) => props.handleDispatchQtyChange(event, buyerReqItemId, sellerPOItem.sellerPOItemId, sellerPOItem.sellerPOId)} 
                            tooltip={isServiceHSNProduct && "Service HSN Products cannot be converted to stock."}
                            tooltipOptions={{ showOnDisabled: true }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DispatchSellerPOItemsStock;